import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';

// Import content from existing pages
import TierPricingContent from './tabs/TierPricingContent';
import FeaturesLimitsContent from './tabs/FeaturesLimitsContent';
import PaywallDisplayContent from './tabs/PaywallDisplayContent';
import BusinessTypesContent from './tabs/BusinessTypesContent';
import ServerConfigContent from './tabs/ServerConfigContent';
import LegalContent from './tabs/LegalContent';
import SupportSettingsContent from './tabs/SupportSettingsContent';
import TipManagementContent from './tabs/TipManagementContent';
import ThirdPartyAuthContent from './tabs/ThirdPartyAuthContent';
import SocialMediaLinksContent from './tabs/SocialMediaLinksContent';
import WebsiteSettingsContent from './tabs/WebsiteSettingsContent';
import StripeBillingContent from './tabs/StripeBillingContent';
import HelpCenterContent from './tabs/HelpCenterContent';
import DeveloperAPIAccessContent from './tabs/DeveloperAPIAccessContent';
import AppVersionPolicyContent from './tabs/AppVersionPolicyContent';

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`config-tabpanel-${index}`}
    aria-labelledby={`config-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </div>
);

const Configuration = () => {
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);

  // Deep-link: /configuration?tab=features opens "Features & Limits" (Hosted AI lives there).
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = (params.get('tab') || '').toLowerCase();
    if (tab === 'features' || tab === 'feature-limits' || tab === '1') {
      setTabValue(1);
    }
  }, [location.search]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden', boxSizing: 'border-box' }}>
      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Tier Pricing" />
          <Tab label="Features & Limits" />
          <Tab label="Paywall Display" />
          <Tab label="Business Types" />
          <Tab label="Server" />
          <Tab label="Third-Party Auth" />
          <Tab label="Tip Management" />
          <Tab label="Support" />
          <Tab label="Help Center" />
          <Tab label="Legal" />
          <Tab label="Social Media Links" />
          <Tab label="Website Settings" />
          <Tab label="Stripe Billing" />
          <Tab label="Developer API Access" />
          <Tab label="App Version" />
        </Tabs>
      </Box>

      {/* Tier Pricing Tab */}
      <TabPanel value={tabValue} index={0}>
        <TierPricingContent />
      </TabPanel>

      {/* Features & Limits Tab */}
      <TabPanel value={tabValue} index={1}>
        <FeaturesLimitsContent />
      </TabPanel>

      {/* Paywall Display Tab */}
      <TabPanel value={tabValue} index={2}>
        <PaywallDisplayContent />
      </TabPanel>

      {/* Business Types Tab */}
      <TabPanel value={tabValue} index={3}>
        <BusinessTypesContent />
      </TabPanel>

      {/* Server Config Tab */}
      <TabPanel value={tabValue} index={4}>
        <ServerConfigContent />
      </TabPanel>

      {/* Third-Party Authentication Tab */}
      <TabPanel value={tabValue} index={5}>
        <ThirdPartyAuthContent />
      </TabPanel>

      {/* Tip Management Tab */}
      <TabPanel value={tabValue} index={6}>
        <TipManagementContent />
      </TabPanel>

      {/* Support Settings Tab */}
      <TabPanel value={tabValue} index={7}>
        <SupportSettingsContent />
      </TabPanel>

      {/* Help Center Tab */}
      <TabPanel value={tabValue} index={8}>
        <HelpCenterContent />
      </TabPanel>

      {/* Legal Tab */}
      <TabPanel value={tabValue} index={9}>
        <LegalContent />
      </TabPanel>

      {/* Social Media Links Tab */}
      <TabPanel value={tabValue} index={10}>
        <SocialMediaLinksContent />
      </TabPanel>

      {/* Website Settings Tab */}
      <TabPanel value={tabValue} index={11}>
        <WebsiteSettingsContent />
      </TabPanel>

      {/* Stripe Billing Tab */}
      <TabPanel value={tabValue} index={12}>
        <StripeBillingContent />
      </TabPanel>

      {/* Developer API Access Tab */}
      <TabPanel value={tabValue} index={13}>
        <DeveloperAPIAccessContent />
      </TabPanel>

      {/* App Version Tab */}
      <TabPanel value={tabValue} index={14}>
        <AppVersionPolicyContent />
      </TabPanel>
    </Box>
  );
};

export default Configuration;

